import React from 'react';
import ReactGA from 'react-ga';
import { Switch, Route, withRouter, useHistory } from "react-router-dom";
import './App.css';
import { TransitionGroup, CSSTransition } from "react-transition-group";

import Homepage from './Homepage';
import Commissions from './Commissions';
import Experiments from './Experiments';
import Config2025 from './projects/Config2025';

import AdidasStateSneakers from './projects/AdidasStateSneakers';
import Apple from './projects/Apple';
import AppleArtText from './projects/AppleArtText';
import Atlantic from './projects/Atlantic';
import Bandcamp from './projects/Bandcamp';
import BandcampExperimental from './projects/BandcampExperimental';
import BloombergBusinessweek from './projects/BloombergBusinessweek';
import BloombergBusinessweekCover from './projects/BloombergBusinessweekCover';
import BloombergBusinessweekCurrencies from './projects/BloombergBusinessweekCurrencies';
import BloombergGreen from './projects/BloombergGreen';
import Bushwig2018 from './projects/Bushwig2018';
import Bushwig2019 from './projects/Bushwig2019';
import CashApp from './projects/CashApp';
import Elsewhere from './projects/Elsewhere';
import HighSnobiety from './projects/HighSnobiety';
import InfoPage from './InfoPage';
import LATimesClimateChange from './projects/LATimesClimateChange';
import LuxMagazine from './projects/LuxMagazine';
import MakerWeek from './projects/MakerWeek';
import Medium from './projects/Medium';
import NewYorker from './projects/NewYorker';
import NewYorkerBitterPill from './projects/NewYorkerBitterPill';
import NewYorkerMDMA from './projects/NewYorkerMDMA';
import NYTimesRightToBeauty from './projects/NYTimesRightToBeauty';
import Nike from './projects/Nike';
import NYTimes from './projects/NYTimes';
import RBMA from './projects/RBMA';
import SpaceNinety8 from './projects/SpaceNinety8';
import ShapeOfSense from './projects/ShapeOfSense';
import Splice from './projects/Splice';
import SportsFandom from './projects/SportsFandom';
import Spotify from './projects/Spotify';
import TheBaffler from './projects/TheBaffler';
import TheVergeOfflineActivities from './projects/TheVergeOfflineActivities';
import Wired from './projects/Wired';
import WSJ from './projects/WSJ';
import YoungGuns from './projects/YoungGuns';




ReactGA.initialize('UA-170809299-1');

function RouterContainer({ location }) {
  let history = useHistory();
  React.useEffect(() => {
    return history.listen(loc => ReactGA.pageview(loc.pathname));
  }, [history]);
    	
    	
  return (
	<TransitionGroup>
    <CSSTransition
      key={location.key}
      timeout={{ enter: 0, exit: 0 }}
      classNames="fade">
				<Switch location={location}>
				
					<Route exact path="/" component={Homepage} />
				<Route path="/commissions" component={Commissions} />
				<Route path="/experiments" component={Experiments} />
				<Route path="/adidas-statesneakers" component={AdidasStateSneakers} />
				<Route path="/apple-art-text" component={AppleArtText} />
				<Route path="/high-snobiety" component={HighSnobiety} />
				<Route path="/latimes-climatechange" component={LATimesClimateChange} />
				<Route path="/newyorker-bitter-pill" component={NewYorkerBitterPill} />
				<Route path="/newyorker-mdma" component={NewYorkerMDMA} />
				<Route path="/nytimes-right-to-beauty" component={NYTimesRightToBeauty} />
				<Route path="/wired" component={Wired} />
				<Route path="/config-2025" component={Config2025} />
				<Route path="/maker-week" component={MakerWeek} />
				<Route path="/shape-of-sense" component={ShapeOfSense} />
				
					<Route path="/apple" component={Apple} />
					<Route path="/atlantic" component={Atlantic} />
					<Route path="/bandcamp" component={Bandcamp} />
					<Route path="/bandcamp_experimental" component={BandcampExperimental} />
					<Route path="/bloomberg-businessweek" component={BloombergBusinessweek} />
					<Route path="/bloomberg-businessweek-cover" component={BloombergBusinessweekCover} />
					<Route path="/bloomberg-businessweek-currencies" component={BloombergBusinessweekCurrencies} />
					<Route path="/bloomberg-green" component={BloombergGreen} />
					<Route path="/bushwig-2019" component={Bushwig2019} />
					<Route path="/bushwig-2018" component={Bushwig2018} />			
					<Route path="/cash-app-ISpy" component={CashApp} />
					<Route path="/elsewhere" component={Elsewhere} />					
					<Route path="/info" component={InfoPage} />
					<Route path="/lux-magazine" component={LuxMagazine} />
					<Route path="/nike" component={Nike} />
					<Route path="/nytimes" component={NYTimes} />
					<Route path="/newyorker" component={NewYorker} />
					<Route path="/rbma" component={RBMA} />				
					<Route path="/uo-space-ninety-8" component={SpaceNinety8} />	
					<Route path="/spotify" component={Spotify} />						
					<Route path="/the-baffler" component={TheBaffler} />
					<Route path="/the-verge-offline-activities" component={TheVergeOfflineActivities} />						
					<Route path="/wsj" component={WSJ} />													
					<Route path="/youngguns" component={YoungGuns} />
					
				</Switch>
     </CSSTransition>
	</TransitionGroup>
  );
}


export default withRouter(RouterContainer);
